import { Navigate, useLocation } from 'react-router-dom';
import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

// Map routes to required permission modules
const ROUTE_PERMISSIONS = {
  '/dashboard/trends': 'trends',
  '/dashboard': 'dashboard',
  '/finance': 'finance_budgets',
  '/hr': 'hr_overview',
  '/sales': 'sales_overview',
  '/support': 'support_overview',
  '/people': 'hr_overview',
  '/assignments': 'assignments',
  '/alerts': 'alerts',
  '/settings/users': 'users',
  '/settings/roles': 'users',
  '/settings/connect-crm': 'settings',
  '/settings/connect-hrms': 'settings',
  '/settings/connect-fixdesk': 'settings',
  '/settings/targets': 'settings',
};

// Ordered list of routes to try when redirecting to first permitted page
const FALLBACK_ROUTES = [
  { path: '/dashboard', module: 'dashboard' },
  { path: '/finance', module: 'finance_budgets' },
  { path: '/hr', module: 'hr_overview' },
  { path: '/sales', module: 'sales_overview' },
  { path: '/support', module: 'support_overview' },
  { path: '/people', module: 'hr_overview' },
  { path: '/assignments', module: 'assignments' },
  { path: '/alerts', module: 'alerts' },
  { path: '/settings/users', module: 'users' },
];

export const getFirstPermittedRoute = (hasPermission) => {
  for (const { path, module } of FALLBACK_ROUTES) {
    if (hasPermission(module, 'view')) return path;
  }
  return '/dashboard';
};

const ProtectedRoute = ({ children }) => {
  const token = sessionStorage.getItem('token');
  const location = useLocation();
  const { hasPermission } = useContext(AuthContext);

  if (!token) {
    return <Navigate to="/" replace />;
  }

  // Check module permission for the current route
  const requiredModule = Object.entries(ROUTE_PERMISSIONS).find(
    ([path]) => location.pathname === path || location.pathname.startsWith(path + '/')
  )?.[1];

  if (requiredModule && !hasPermission(requiredModule, 'view')) {
    const fallback = getFirstPermittedRoute(hasPermission);
    if (fallback === location.pathname) return children;
    return <Navigate to={fallback} replace />;
  }

  return children;
};

export default ProtectedRoute;
